var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-3 w-full"},[(_vm.input.type === 'input-consent')?_c('p',{staticClass:"text-terms text-xs block mb-5",class:{ 'text-center': _vm.isAlignmentCenter },domProps:{"innerHTML":_vm._s(_vm.translations.text)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }